import React, {FC, PropsWithChildren} from 'react';

import {Avatar, AvatarProps} from './avatar';
import {AvatarHover} from './avatarHover';
import {AvatarImage} from './avatarImage';

/*
 * Props.
 */

interface ImageTeammateAvatarProps extends AvatarProps {
  avatarUrl: string;
  isFaded?: boolean;
  supportsHover?: boolean;
  hasDarkerHover?: boolean;
}

/*
 * Component.
 */

export const ImageTeammateAvatar: FC<PropsWithChildren<ImageTeammateAvatarProps>> = (props) => (
  <Avatar {...props}>
    <AvatarImage imageUrl={props.avatarUrl} isFaded={props.isFaded} />
    {props.supportsHover && <AvatarHover isDarker={props.hasDarkerHover} />}
    {props.children}
  </Avatar>
);
